const MessageInfo = {
  s_101:"保存成功",
  s_102:"修改密码成功",
  s_103:"删除成功",

  e_202:"权限不足，无法查看本条数据",
  e_203:"保存失败！审批者与观察者不能含有相同用户。",
  e_204:"保存失败！数据未修改",

  m_301:'编号由系统自动生成',
  m_302:'此操作将删除该类（使用中则无法删除）, 是否继续?'
};

export default MessageInfo;